export default "__VITE_ASSET__fOYiJfuu__";